<template>
    <panel-navigation>

        <div v-show="me.clsa_command_enabled" style="float: right;">
            Month:
            <!-- Render only when months exist -->
            <select v-if="months.length" v-model="selectedMonth" style="background: #FFFFFF; border: solid 1px #CCCCCC; border-radius: 5px; padding: 5px;" @change="getMessages(); updateMonthDates(selectedMonth)">
              <option
                v-for="month in months"
                :key="month.value"
                :value="month.value"
              >
                {{ month.label }}
              </option>
            </select>

            <!-- Optional debug -->
            <!-- <pre>{{ selectedMonth }}</pre> -->
        </div>

        <h1 class="text-lg font-semibold mb-3">
            Refunds
        </h1>
        <hr class="border-b border-gray-100 mb-3">

        <template>
          <v-expansion-panels v-model="panel" accordion flat dense>
              <v-expansion-panel>
              <v-expansion-panel-header>Stats</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <div v-if="!me.lsa_command_enabled" class="mt-2">
                    <product-access-required product="lsa_command" />
                  </div>

                  <div v-else>

                    <div v-if="!loading && dashboard_data" class="space-y-6 pt-3">

                      <!-- LEADS -->
                      <section>
                        <div class="flex flex-wrap -mx-2">
                          <StatCard
                            title="Total Leads"
                            icon="mdi-account-multiple"
                            :value="dashboard_data.total_leads"
                            :current="dashboard_data.total_leads"
                            :previous="dashboard_data_prev.total_leads"
                            :change="comparisons.total_leads"
                          />

                          <StatCard
                            title="Total Calls"
                            icon="mdi-phone"
                            :value="dashboard_data.total_calls"
                            :current="dashboard_data.total_calls"
                            :previous="dashboard_data_prev.total_calls"
                            :change="comparisons.total_calls"
                            :tooltiptext="'Total Calls might be different than Total Leads because a lead can call multiple times'"
                          />

                          <StatCard
                            title="Connected Calls"
                            icon="mdi-phone-check"
                            :value="dashboard_data.total_connected_calls"
                            :current="dashboard_data.total_connected_calls"
                            :previous="dashboard_data_prev.total_connected_calls"
                            :change="comparisons.total_connected_calls"
                          />

                          <StatCard
                            title="Charged"
                            icon="mdi-cash-check"
                            :value="dashboard_data.charged_leads_total"
                            :current="dashboard_data.charged_leads_total"
                            :previous="dashboard_data_prev.stats.charged_leads_total"
                            :change="comparisons.charged_leads_total"
                            :tooltiptext="'These are the leads that were permanently charged by Google LSA'"
                          />

                          <StatCard
                            title="Message Leads"
                            icon="mdi-message-text"
                            :value="dashboard_data.total_message_leads"
                            :current="dashboard_data.total_message_leads"
                            :previous="dashboard_data_prev.total_message_leads"
                            :change="comparisons.total_message_leads"
                          />

                          <StatCard
                            title="Lead Quality"
                            icon="mdi-poll"
                            :value="dashboard_data.lead_quality"
                            :current="dashboard_data.lead_quality"
                            :previous="dashboard_data_prev.lead_quality"
                            :change="comparisons.lead_quality"
                          />

                          <StatCard
                            title="Not Charged"
                            icon="mdi-cash-remove"
                            :value="dashboard_data.not_charged_leads"
                            :current="dashboard_data.not_charged_leads"
                            :previous="dashboard_data_prev.not_charged_leads"
                            :change="comparisons.not_charged_leads"
                            :tooltiptext="'These are the leads that were not charged by LSA from the moment the leads were created'"
                          />

                          <StatCard
                            title="Qualified Leads"
                            icon="mdi-check-circle"
                            :value="dashboard_data.stats.charged_leads"
                            :current="dashboard_data.stats.charged_leads"
                            :previous="dashboard_data_prev.stats.charged_leads"
                            :change="comparisons.charged_leads"
                          />

                          <StatCard
                            title="Credited"
                            icon="mdi-cash-refund"
                            :value="dashboard_data.stats.approved_disputes"
                            :current="dashboard_data.stats.approved_disputes"
                            :previous="dashboard_data_prev.stats.approved_disputes"
                            :change="comparisons.approved_disputes"
                            :total_refunds="dashboard_data.stats.total_approved_disputes"
                            :refunds_amount="dashboard_data.refunds_amount"
                            :refunds_amount_total="dashboard_data.refunds_amount_total"
                          />

                          <!-- <StatCard
                            title="Conversion Rate"
                            icon="mdi-percent"
                            :value="dashboard_data.stats.conversion + '%'"
                            :current="dashboard_data.stats.total_converted_value"
                            :previous="dashboard_data_prev.stats.total_converted_value"
                            :change="comparisons.total_converted_value"
                          />
                          <StatCard
                            title="Response Rate"
                            icon="mdi-clock-check"
                            :value="dashboard_data.stats.lsa_response_rate + '%'"
                            :current="dashboard_data.stats.lsa_response_rate"
                            :previous="dashboard_data_prev.stats.lsa_response_rate"
                            :change="comparisons.lsa_response_rate"
                          />

                          <StatCard
                            title="Under 30s Response"
                            icon="mdi-timer"
                            :value="dashboard_data.stats.lsa_30_seconds_response_rate + '%'"
                            :current="dashboard_data.stats.lsa_30_seconds_response_rate"
                            :previous="dashboard_data_prev.stats.lsa_30_seconds_response_rate"
                            :change="comparisons.lsa_30_seconds_response_rate"
                          />

                          <StatCard
                            title="Message Response Time"
                            icon="mdi-message-clock"
                            :value="dashboard_data.stats.lsa_messages_response_rate + ' hrs'"
                            :current="dashboard_data.stats.lsa_messages_response_rate"
                            :previous="dashboard_data_prev.stats.lsa_messages_response_rate"
                            :change="comparisons.lsa_messages_response_rate"
                            reverse
                          /> -->
                          <!-- <StatCard
                            title="Impressions"
                            icon="mdi-eye"
                            :value="dashboard_data.stats.total_impressions.toLocaleString()"
                            :current="dashboard_data.stats.total_impressions"
                            :previous="dashboard_data_prev.stats.total_impressions"
                            :change="comparisons.total_impressions"
                          />

                          <StatCard
                            title="Clicks"
                            icon="mdi-mouse"
                            :value="dashboard_data.stats.total_clicks.toLocaleString()"
                            :current="dashboard_data.stats.total_clicks"
                            :previous="dashboard_data_prev.stats.total_clicks"
                            :change="comparisons.total_clicks"
                          />

                          <StatCard
                            title="Total Cost"
                            icon="mdi-currency-usd"
                            :value="'$' + dashboard_data.stats.total_cost.toLocaleString()"
                            :current="dashboard_data.stats.total_cost"
                            :previous="dashboard_data_prev.stats.total_cost"
                            :change="comparisons.total_cost"
                          /> -->
                        </div>
                      </section>

                    </div>
                  </div>

              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>
        </template>
    </panel-navigation>
</template>

<script>
import { mapState } from 'vuex'
import $ from 'jquery';
import axios from 'axios'
import moment from 'moment'
import StatCard from  "@/views/panel/Call/StatCard.vue"
import PanelNavigation from '@/components/PanelNavigation.vue'
import ProductAccessRequired from '@/components/reusable/ProductAccessRequired.vue'

export default {
    components: {
        StatCard,
        PanelNavigation,
        ProductAccessRequired
    },
    computed: {
      ...mapState({
          me: state => state.me.me
      })
    },
    data() {
        return {
            messages: [],
            loading: true,

            new_note: "",
            show_notes_dialog: false,
            notes_lead: null,
            savingNote: false,

            showBlandRecording: false,
            loading_bland_recording: true,
            bland_recording_data: {},

            showLsaRecordings: false,
            loading_lsa_recordings: true,
            lsa_recording_data: {},

            showLsaMessages: false,
            loading_lsa_messages: true,
            lsa_messages_displayed: [],
            lsa_item: null,

            cutoffDate: null,

            selected: [],

            company_name: "",
            uuid: "",
            ai_started_on: "",

            survey_started_on: "",

            selectedMonth: '',
            months: [],

            startDate: '', // Start date of the selected month
            endDate: '',   // End date of the selected month

            dashboard_data: [],
            dashboard_data_prev: [],
            comparisons: {},

            custom_tags: [],
            custom_statuses: [],

            aiSuggestionById: {}, // { [leadId]: { satisfaction, reason, comment, satisfactionLabel, reasonLabel } }
            aiLoadingById: {},    // { [leadId]: boolean }
            aiLoadingInakePerformanceById: {},    // { [leadId]: boolean }
            aiLoadingAiPerformanceById: {},    // { [leadId]: boolean }
            aiLoadingLeadQualityPerformanceById: {},    // { [leadId]: boolean }

            tags_items: [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 3,
                    text: 'Opportunity'
                },{
                    index: 4,
                    text: 'Meeting Scheduled'
                },{
                    index: 5,
                    text: 'Became Customer'
                },{
                    index: 'Signed',
                    text: 'Signed'
                }
                ,{
                    index: 'Booked for Consultation',
                    text: 'Booked for Consultation'
                }
                ,{
                    index: 'Declined/Not a lead',
                    text: 'Declined/Not a lead'
                }
                ,{
                    index: 'Wrong Number',
                    text: 'Wrong Number'
                }
                ,{
                    index: 'No Response',
                    text: 'No Response'
                }
                ,{
                    index: 'Existing Client',
                    text: 'Existing Client'
                }
                ,{
                    index: 'Failed Sign Up',
                    text: 'Failed Sign Up'
                }
                ,{
                    index: 'Following Up/Working on this one',
                    text: 'Following Up/Working on this one'
                }
                ,{
                    index: 'E-Doc sent not signed',
                    text: 'E-Doc sent not signed'
                }
                ,{
                    index: 'Booked to Service',
                    text: 'Booked to Service'
                }
                ,{
                    index: 'Booked for Appointment',
                    text: 'Booked for Appointment'
                }
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                }, {
                    index: 'Duplicate Call',
                    text: 'Duplicate Call'
                },
            ],

            lineChartMetricsOptions: {
              colors: ["rgb(0, 143, 251)", "rgb(254, 176, 25)", "#16a34a", "rgb(255, 69, 96)", "rgb(119, 93, 208)", "#4284C1", "rgb(0, 227, 150)", "rgb(56, 193, 167)"],
              chart: {
                  id: "line-chart",
                  toolbar: {
                      show: false
                  }
              },
              legend: {
                  show: false
                },
              xaxis: {
                  categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                  ],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: [
                {
                  opposite: false,
                  labels: {
                    show: true
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                }
              ],
              stroke: {
                  curve: "smooth",
                  width: [4, 4, 4, 4, 4, 9, 4] // last line thicker
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },

              tooltip: {
                shared: true,
                intersect: false,
                y: [{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": $" + y;
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseFloat(y).toFixed(2);
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }]
              }
          },
          lineChartMetricsSeries: [
              {
                name: "Reviews",
                data: [30, 40, 25, 50, 49, 49],
              },
          ],

          legend: [
            { value: 5, label: "Very good", class: "score-1" },
            { value: 4, label: "Good", class: "score-2" },
            { value: 3, label: "Neutral", class: "score-3" },
            { value: 2, label: "Bad", class: "score-4" },
            { value: 1, label: "Very bad", class: "score-5" },
          ],

          panel: 0,
          panel2: 0,

          hoveredLegend: null,

          legendItems: [
              {
                name: "Impressions",
                color: "rgb(0, 143, 251)",
                description: "Total times your ad was shown to users.",
                disabled: false
              },
              {
                name: "Absolute Top Impressions Rate",
                color: "rgb(254, 176, 25)",
                description: "Percentage of your search ad impressions shown in the most prominent position on the page.", // from API docs :contentReference[oaicite:0]{index=0}
                disabled: false
              },
              {
                name: "Under 30s Response Rate",
                color: "#16a34a",
                description: "Percentage of how many leads were responded in under 30 seconds.", // from API docs :contentReference[oaicite:0]{index=0}
                disabled: false
              },
              {
                name: "Lead Volume",
                color: "rgb(255, 69, 96)",
                description: "The number of leads generated — typically form submissions or qualified contacts.",
                disabled: false
              },
              {
                name: "Clicks",
                color: "rgb(119, 93, 208)",
                description: "Number of times users clicked on your ad.",
                disabled: false
              },
              {
                name: "Total Cost",
                color: "#4284C1",
                description: "Total ad spend over the chosen period.",
                disabled: false
              },
              {
                name: "Lead Quality",
                color: "rgb(0, 227, 150)",
                description: "A score from 1 to 5 indicating how qualified the leads are — higher means more likely to convert.",
                disabled: false
              },
              {
                name: "Credited",
                color: "rgb(56, 193, 167)",
                description: "Leads that were originally charged but later refunded due to invalid submissions, cancellations, or quality adjustments after we started submitting your surveys.",
                disabled: false
              }
            ],

            shouldShowChatConversation: false,
            loading_chat_conversation: false,

            new_ai_message: "",
            sendingAiMessage: false,
            ai_messages_lead: null,

            savingAiFeedback: false,

            show_photos_dialog: false,
            photos: [], // array of photo URLs
            savingPhotos: false,
            lead_id: null, // set this when opening dialog

            uploading: false
            
        }
    },

    methods: {
            openPhotosDialog(lead) {
                this.lead_id = lead.id

                if (lead.photos) {
                    this.photos = lead.photos.split(',')
                } else {
                    this.photos = []
                }

                this.show_photos_dialog = true
            },

            async onUpload() {
              // console.log(this.file);
              if (this.file !== null) {
                this.uploading = true
                let formData = new FormData()
                formData.append("file", this.file)

                try {
                  let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })

                  let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-profile-picture`, {
                    profile_image: response.data.url
                  }, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })

                  this.profile.profile_image = response.data.url

                }catch(e){
                  console.log(e)
                }

                this.file = null
                this.uploading = false
              }
            },

            handlePhotoUpload(event) {
                let self = this;
                let files = event.target.files
                this.uploading = true;

                for (let i = 0; i < files.length; i++) {
                    let formData = new FormData()
                    formData.append('file', files[i])

                    axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
                        headers: { 'Authorization': 'Bearer ' + self.$store.state.auth.jwt }
                    })
                    .then(res => {
                        self.photos.push(res.data.url)
                        self.uploading = false;
                    })
                }
            },

            removePhoto(index) {
                this.photos.splice(index, 1)
            },

            savePhotos() {
                let self = this;
                this.savingPhotos = true

                axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-lead-photos`, {
                      lead_id: this.lead_id,
                        photos: this.photos.join(',')
                  }, {
                      headers: {
                          'Authorization': 'Bearer ' + self.$store.state.auth.jwt
                      }
                  }).then(() => {
                    self.savingPhotos = false
                    self.show_photos_dialog = false
                    self.getMessages(true)
                })
                .catch(() => {
                    self.savingPhotos = false
                })
            },

            async switchAiResponseEnabled(lead) {
                console.log('lead', lead);

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-response-enabled`, {
                    lead_id: lead.id,
                    ai_enabled: lead.ai_enabled
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                console.log('response', response);
            },

            async sendLsaReply() {
                this.sendingLsaMessage = true;
                
                let self = this;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                    lead_id: self.lsa_messages_lead.id,
                    message: self.new_lsa_message
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                let timezone = this.me.timezone;

                this.lsa_messages_displayed.push({
                    event_time: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                    participant_type: 2,
                    text: self.new_lsa_message
                });

                this.sendingLsaMessage = false;
                this.new_lsa_message = "";

                setTimeout(function() {
                    var objDiv = document.getElementById("lsa-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            async sendAiReply() {
                this.sendingAiMessage = true;
                
                let self = this;

                console.log('this.bland_recording_data', this.bland_recording_data);

                if (this.bland_recording_data.sources && this.bland_recording_data.sources.indexOf('lsa') != -1) {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                        lead_id: this.bland_recording_data.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }
                else {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-ai-message`, {
                        lead_id: self.ai_messages_lead.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }

                let timezone = this.me.timezone;

                try {
                    this.bland_recording_data.transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        custom_name: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    });
                }
                catch (e) {

                }

                try {
                    this.bland_transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        content: self.new_ai_message,
                        custom_name: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    });
                }
                catch (e) {

                }

                this.sendingAiMessage = false;
                this.new_ai_message = "";

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("ai-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("chat-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }
            },

            async showChatConversation(item) {
                if (this.me.is_medical) return false;
                
                let self = this;

                this.shouldShowChatConversation = true;
                this.loading_chat_conversation = true;
                this.ai_messages_lead = item;

                if (this.ai_messages_lead.ai_enabled == 1)
                    this.ai_messages_lead.ai_enabled = true;
                else
                    this.ai_messages_lead.ai_enabled = false;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, {
                    lead_id: item.id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                this.bland_transcription = response.data.transcription;
                this.loading_chat_conversation = false;

                setTimeout(function() {
                    var objDiv = document.getElementById("chat-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            handleLegendHover(item) {
                this.hoveredLegend = item.name;

                this.legendItems.forEach(i => {
                  if (i.name !== item.name && !i.disabled) {
                    this.$refs.apexChart.hideSeries(i.name);
                  }
                });
              },

              handleLegendLeave() {
                this.hoveredLegend = null;

                this.legendItems.forEach(i => {
                  if (!i.disabled) {
                    this.$refs.apexChart.showSeries(i.name);
                  }
                });
              },

              toggleSeries(item) {
                item.disabled = !item.disabled;
                this.$refs.apexChart.toggleSeries(item.name);
              },

            async generateAiIntakePerformance(item) {
                this.$set(this.aiLoadingInakePerformanceById, item.id, true);
                try {
                let transcript = item.lsa_transcription;

                if (!transcript)
                    transcript = item.lsa_messages;

                const intake_performance = await this.callOpenAIForIntakePerformance(item.id, transcript);

                console.log('intake_performance', intake_performance);

                item.intake_performance = intake_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingInakePerformanceById, item.id, false);
                }
            },

            async generateAiPerformance(item) {
                this.$set(this.aiLoadingAiPerformanceById, item.id, true);
                try {
                let transcript = item.bland_transcription;

                const ai_performance = await this.callOpenAIForAiPerformance(item.id, transcript);

                console.log('ai_performance', ai_performance);

                item.ai_performance = ai_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingAiPerformanceById, item.id, false);
                }
            },

            async callOpenAIForIntakePerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-intake-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            async callOpenAIForAiPerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-ai-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            isLocalHost() {
                return this.getHost().indexOf('localhost') != -1;
            },

            getMonthlyReport() {
                window.open('/leads-public-survey/' + this.me.uuid + "?cutoff_date=" + moment().subtract(2, 'weeks').format('YYYY-MM-DD'));
            },

            async sendMonthlyReport(item, qualify_status) {
                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/send-monthly-survey-report`, {
                    now: 2
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                })

                this.$swal({
                    title: "Email sent!",
                    text: "The report has been successfully sent to the customer!",
                    showCancelButton: false,
                });
            },

            downloadCsv() {
                this.exporting = true;

                let self = this;

                let csv = 'Customer, Timestamp, Lead Type, Sources, Charge Status, Survey Score, Survey Notes, Intake Score, Intake Notes, AI Score, AI Rating\n';
                this.messages.forEach((row) => {

                    let customer = "";

                    if (row.job_type) {
                        customer = row.job_type + " - ";
                    }

                    if (row.tracking_number) {
                        customer += row.tracking_number;
                    }
                    else if (row.customer_phone_number) {
                        customer += row.customer_phone_number;
                    }

                    let tags = [];

                    for (var i in row.tag) {
                        for (var j in this.tags_items) {
                            if (this.tags_items[j].index == row.tag[i]) {
                                tags.push(this.tags_items[j].text);
                            }
                        }
                    }

                    let lead_status = "Not Set";

                    switch (row.qualify_status) {
                        case 1:
                            lead_status = 'Qualified';
                        break;
                        case -1:
                            lead_status = 'Unqualified';
                        break;
                        case 2:
                            lead_status = 'Spam';
                        break;
                    }

                    if (row.qualify_status != 0 && row.qualify_status != 1 && row.qualify_status != 2 && row.qualify_status != -1) {
                        lead_status = row.qualify_status;
                    }

                    let survey_score = "N/A";
                    let survey_notes = "N/A";
                    let intake_score = "N/A";
                    let intake_notes = "N/A";
                    let ai_score = "N/A";
                    let ai_notes = "N/A";

                    if (row.rated_at) {
                        survey_score = self.convertSatisfactionToNumber(row.satisfaction);

                        survey_notes = row.summary || row.additional_comments;
                    }

                    if (row.intake_performance) {
                        intake_score = row.intake_performance.rating;
                        intake_notes = row.intake_performance.explanation;
                    }

                    if (row.ai_performance) {
                        ai_score = row.ai_performance.rating;
                        ai_notes = row.ai_performance.explanation;
                    }

                    let csv_data = [
                        '"' + customer + '"',
                        '"' + self.displayTimestamp(row.lead_creation_date) + '"',
                        '"' + row.lead_type + '"',
                        '"' + row.sources.replace('bland', 'AI') + '"',
                        // '"' + tags.join(",") + '"',
                        '"' + row.charge_status + '"',
                        '"' + survey_score + '"',
                        '"' + survey_notes + '"',
                        '"' + intake_score + '"',
                        '"' + intake_notes + '"',
                        '"' + ai_score + '"',
                        '"' + ai_notes + '"'
                    ]

                    csv += csv_data.join(',');
                    csv += "\n";
                });

                csv = csv.replace(/null/g, "");
            
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'diyai-leads.csv';
                anchor.click();

                this.exporting = false;
            },

          async markBooked(item) {
                item.marking_booked = true;

                item.is_lsa_booked = true;

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/inbox/mark-lead-booked`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },

          async archiveLead(item) {

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/archive-lead`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },

          async unArchiveLead(item) {

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/unarchive-lead`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },
          async saveNote() {
              if (!this.new_note)
                  return;

              this.savingNote = true;
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/add-note`, {
                  lead_id: this.notes_lead.id,
                  note: this.new_note
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.savingNote = false;
              this.notes_lead = response.data.lsa_lead;
              this.new_note = '';

              this.getMessages(true);
          },

          async deleteNote(index) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/delete-note`, {
                  lead_id: this.notes_lead.id,
                  note_index: index
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.notes_lead = response.data.lsa_lead;

              this.getMessages(true);
          },

          async setTag(item, tag) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-tag-message`, {
                  message_id: item.id,
                  tag: tag
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              })

              this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
              this.getMessages(true);
          },

          async removeTag(item, tag) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/remove-tag-message`, {
                  message_id: item.id,
                  tag: tag
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              })

              this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
              this.getMessages(true);
          },
          showEditValue(item) {
              $('.lsa-show-value-' + item.id).hide();
              $('.lsa-edit-value-' + item.id).show();
              setTimeout(function() {
                  $('.lsa-edit-value-' + item.id).focus();
              }, 20);
          },

          cancelEditValue(item) {
              $('.lsa-show-value-' + item.id).show();
              $('.lsa-edit-value-' + item.id).hide();
          },

          async editValue(item) {
              item.value = $('.lsa-edit-value-' + item.id + ' input').val();
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-value-message`, {
                  item: item
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
              this.getMessages(true);

              $('.lsa-show-value').show();
              $('.lsa-edit-value').hide();
          },


          displaySpeakerTimestamp(milliseconds, firstItemMilliseconds) {
              //Get hours from milliseconds
              var hours = milliseconds / (1000*60*60);

              //if (firstItemMilliseconds < 1000)
                //hours = milliseconds / (100*60*60);

              var absoluteHours = Math.floor(hours);
              var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

              //Get remainder from hours and convert to minutes
              var minutes = (hours - absoluteHours) * 60;
              var absoluteMinutes = Math.floor(minutes);
              var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

              //Get remainder from minutes and convert to seconds
              var seconds = (minutes - absoluteMinutes) * 60;
              var absoluteSeconds = Math.floor(seconds);
              var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

              return h + ':' + m + ':' + s;
        },

        async showBlandRecordingFunction(item) {

          this.ai_messages_lead = item;
          this.ai_messages_lead.show_ai_feedback = false;

          if (this.ai_messages_lead.ai_enabled == 1)
              this.ai_messages_lead.ai_enabled = true;
          else
              this.ai_messages_lead.ai_enabled = false;

          let self = this;

          this.showBlandRecording = true;
          this.loading_bland_recording = true;
          
          this.bland_recording_data.recording_url = item.bland_recording_url;
          this.bland_recording_data.sources = item.sources;
          this.bland_recording_data.lead_type = item.lead_type;
          this.bland_recording_data.id = item.id;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.bland_recording_data.transcription = response.data.transcription;

          let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
          original_ai_messages = original_ai_messages.messages;

          console.log('original_ai_messages', original_ai_messages);

          if (item.lead_type == "MESSAGE" && item.sources.indexOf('lsa') != -1) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                  lead_id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              for (var i in response.data.lsa_messages) {
                  response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                  response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                  response.data.lsa_messages[i].is_person = response.data.lsa_messages[i].is_bland;
                  // response.data.lsa_messages[i].is_person = 0;
                  response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                  response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                  for (var j in original_ai_messages) {
                      console.log('compare 1:', response.data.lsa_messages[i].message);
                      console.log('compare 2:', original_ai_messages[j].body);
                      if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                          console.log("FOUD AI MESSAGE");
                          console.log(response.data.lsa_messages[i].message);
                          response.data.lsa_messages[i].is_person = 0;
                          break;
                      }
                  }

                  if (response.data.lsa_messages[i].text.indexOf('did you get my last message') != -1) {
                      response.data.lsa_messages[i].is_person = 0;
                  }
              }

              this.bland_recording_data.transcription.messages = response.data.lsa_messages;
          }

          this.bland_recording_data.summary = response.data.summary;
          this.bland_recording_data.customer_name = item.customer_name;
          this.bland_recording_data.customer_email = item.customer_email;
          this.bland_recording_data.ai_provided_phone_number = item.ai_provided_phone_number;
          this.bland_recording_data.job_type = item.job_type;
          this.bland_recording_data.call_ended_by = item.call_ended_by;
          this.bland_recording_data.sentiment = response.data.sentiment;
          this.bland_recording_data.topics_discussed = response.data.topics_discussed;
          this.bland_recording_data.issues_raised = response.data.issues_raised;
          this.bland_recording_data.analysis = response.data.analysis;
          this.bland_recording_data.variables = response.data.variables;
          this.loading_bland_recording = false;

          if (response.data.recording_url)
              this.bland_recording_data.recording_url = response.data.recording_url;

          setTimeout(function() {
              if (self.bland_recording_data.recording_url) {
                  document.querySelector('#bl-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.bland_recording_data.recording_url + '" style="width: 100%"></audio>';
              }
          }, 500);

          setTimeout(function() {
              var objDiv = document.getElementById("ai-dialog-messages-list");
              objDiv.scrollTop = objDiv.scrollHeight;
          }, 10);
      },

      async showLsaCallRecordings(item) {
          
          let self = this;

          console.log('this.lsa_item', this.lsa_item);

          this.showLsaRecordings = true;
          this.loading_lsa_recording = true;
          this.lsa_item = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-recordings`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_recordings = false;

          this.lsa_recording_data = JSON.parse(JSON.stringify(response.data));

          console.log('this.lsa_recording_data', this.lsa_recording_data);

          if (response.data.recordings.length > 0) {
              let recordings_html = '';

              for (var i in response.data.recordings) {
                  recordings_html += '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><div style="margin-bottom: 15px;"><audio onwindowresize="" controls="true" class="u-hide" src="' + response.data.recordings[i] + '" style="width: 100%"></audio></div>';
              }

              setTimeout(function() {
                  document.querySelector('#lsa-audio-el-here').innerHTML = recordings_html;
              }, 500);
          }
          else {
              document.querySelector('#lsa-audio-el-here').innerHTML = 'No recordings found.';
          }
      },

      async showLsaMessagesFunction(item) {
      
          // console.log('item.sources', item.sources)
          // console.log('itemplmmmm', item);

          // console.log(1);

          // console.log("item.sources.indexOf('bland')", item.sources.indexOf('bland'))

          if (item.sources.indexOf('bland') != -1) {
              console.log(2);
              this.showBlandRecordingFunction(item);
              return;
          }

          console.log(3);

          
          let self = this;

          this.showLsaMessages = true;
          this.loading_lsa_messages = true;
          this.lsa_messages_lead = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_messages = false;

          this.lsa_messages_displayed = response.data.lsa_messages;
          this.loading_lsa_messages = false;
      },

        readCutoffFromQuery() {
          const params = new URLSearchParams(window.location.search);
          const cutoff = params.get("cutoff_date");

          if (cutoff && moment(cutoff, "YYYY-MM-DD", true).isValid()) {
            this.cutoffDate = moment(cutoff, "YYYY-MM-DD").startOf("day");
          } else {
            this.cutoffDate = moment().subtract(2, 'weeks').format('YYYY-MM-DD');
          }
        },

        isNewLead(item) {
          if (!this.cutoffDate || !item.lead_creation_date) return false;

          const leadDate = moment(item.lead_creation_date, "YYYY-MM-DD HH:mm:ss", true);
          if (!leadDate.isValid()) return false;

          return leadDate.isAfter(this.cutoffDate);
        },

        getRowClass(item) {
          return this.isNewLead(item) ? "new-lead-highlight" : "";
        },

        getHost() {
        return window.location.host;
        },

        isOnlyAi() {
            return !this.isAccelerate();
        },

        isAccelerate() {
            //  || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
            return this.getHost() == 'lsa.accelerateyourmarketing.com';
        },

        getCustomTagColor(tag) {
            for (var i in this.custom_tags) {
                if (this.custom_tags[i].tag == tag)
                    return this.custom_tags[i].color;
            }

            return "";  
        },

        getCustomStatusColor(status) {
            for (var i in this.custom_statuses) {
                if (this.custom_statuses[i].status == status)
                    return this.custom_statuses[i].color;
            }

            return "";  
        },

        formatDate: function(date, format = "MM/DD/YYYY") {
            return moment(String(date)).format(format)
        },

        displayTimestamp(date) {
            let timezone = "America/New_York";

            // .tz(timezone)
            return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
        },

        displayDuration(seconds) {
            return date;
        },

        trainAgentWithSelectedCalls() {
            this.selected = [];

            this.$swal({
                title: "Saved",
                text: "Selected calls will be used as knowledge for AI Agent, based on each call's quality!",
                showCancelButton: false,
            });
        },
        
        satisfactionLabel(value) {
            const map = {
                1: 'Very Satisfied',
                2: 'Satisfied',
                3: 'Neutral',
                4: 'Unsatisfied',
                5: 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        satisfactionLabelByTexts(value) {
            const map = {
                "VERY_SATISFIED": 'Very Satisfied',
                "SATISFIED": 'Satisfied',
                "NEUTRAL": 'Neutral',
                "DISSATISFIED": 'Unsatisfied',
                "VERY_DISSATISFIED": 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        convertSatisfactionToNumber(value) {
            const map = {
                "VERY_SATISFIED": 5,
                "SATISFIED": 4,
                "NEUTRAL": 3,
                "DISSATISFIED": 2,
                "VERY_DISSATISFIED": 1
            };
            return map[value] || 3;
        },

        convertCreditDecisionToNumber(value) {
            const map = {
                'Not specified': 3,
                'Unknown in this API version': 3,
                'Credit issued, cap not reached': 5,
                'Credit issued, cap reached': 4,
                'No credit, cap reached': 2,
                'No credit, not eligible': 1

            };
            return map[value] || 3;
        },

        getSatisfactionColor(value) {
            const map = {
                "1": "#ef4444",
                "2": "#fb923c",
                "3": "#facc15",
                "4": "#22c55e",
                "5": "#16a34a"
            };

            return map[value];
        },

        reasonLabel(reason) {
            // If you store reasons as strings already, just return them.
            // If your backend uses codes, map those codes to labels here.
            return reason || '—';
        },

        normalizedProviders(item) {
            // Build a unique set of providers from item.sources ONLY ONCE
            const src = (item.sources || '').toLowerCase()
            const list = []
            const push = (cond, key, title, srcImg, onClick) => {
            if (cond) list.push({ key, title, src: srcImg, onClick })
            }


            // Important: render EACH provider ONCE. We no longer render separate icons for call/message.
            push(src.includes('lsa'), 'lsa', 'This is a Google Local Service Ads lead', require('@/assets/images/lsa.webp'), (row) => {
            // prefer messages when lead_type is MESSAGE, else show call recordings
            if (row.lead_type === 'MESSAGE') this.showLsaMessagesFunction(row)
            else this.showLsaCallRecordings(row)
            })


            push(src.includes('callrail'), 'callrail', 'CallRail', require('@/assets/images/callrail.png'), (row) => this.showCallRailRecordingFunction(row))


            push(src.includes('bland'), 'ai', 'This is a call that we responded to using AI', require('@/assets/images/bland.png'), (row) => this.showBlandRecordingFunction(row))


            push(src.includes('web'), 'web', 'This is a Web Chat conversation', require('@/assets/images/bland.png'), (row) => this.showChatConversation(row))

            push(src.includes('google_ai'), 'google_ai', 'This is a call that came in using Google AI', require('@/assets/images/review-services/www.google.com.png'), (row) => this.showChatConversation(row))


            // Avoid duplicate icons added from merged_lead by ONLY using current row sources.
            // If you want to show merged sources too, dedupe by key:
            // const merged = (row.merged_lead?.[0]?.sources || '').toLowerCase()
            // ... add conditionally if not already in list.


            // De-duplicate by key just in case
            const seen = new Set()
            return list.filter(p => (seen.has(p.key) ? false : seen.add(p.key)))
        },

        displayDuration(time) {
            var sec_num = time // don't forget the second param
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            return hours+':'+minutes+':'+seconds;
        },

        formatPhoneNumber(phoneNumberString) {
            const match = phoneNumberString
    .replace(/\D+/g, '').replace(/^1/, '')
    .match(/([^\d]*\d[^\d]*){1,10}$/)[0]
    const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
    const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
    const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
    return `${part1}${part2}${part3}`
        },

        playAudio(item) {
            if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
                let elements = document.getElementsByClassName('audio-element-wrapper');

                for (var i in elements) {
                    try {
                        elements[i].style.display = 'none';
                    }
                    catch (e) {}
                }

                let elements2 = document.getElementsByClassName('audio-element');

                for (var i in elements) {
                    try {
                        elements2[i].pause();
                        elements2[i].currentTime = 0;
                    }
                    catch (e) {}
                }

                let elements3 = document.getElementsByClassName('audio-element-icon');

                for (var i in elements) {
                    try {
                        elements3[i].style.display = 'block';
                    }
                    catch (e) {}
                }

                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
                document.getElementById('audio-element-' + item.id).play();

                document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

                
            }
            else {
                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
                document.getElementById('audio-element-' + item.id).pause();
                document.getElementById('audio-element-' + item.id).currentTime = 0;

                document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
            }
        },

        async getMessages(silent = false) {
            let self = this;

            if (!silent)
                this.loading = true;

            // let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
            //     date_filter: this.date_filter,
            //     search: this.search,
            //     tag: this.tag,
            //     qualify_status: this.qualify_status,
            //     archived_filter: this.archived_filter,
            //     for_report: 1,
            //     month: this.selectedMonth
            // }, {
            //     headers: {
            //         'RG-Auth-Loc-Uu': this.getUUID()
            //     }
            // })

            // this.messages = response.data.messages;
            // this.lsa_leads_count = response.data.lsa_leads_count;
            // this.ai_leads_count = response.data.ai_leads_count;
            // this.ai_leads_count_msg = response.data.ai_leads_count_msg;
            // this.ai_leads_count_voice = response.data.ai_leads_count_voice;
            // this.callrail_leads_count = response.data.callrail_leads_count;
            // this.converted_leads_count = response.data.converted_leads_count;
            // this.converted_ai_leads_count = response.data.converted_ai_leads_count;
            // this.converted_human_leads_count = response.data.converted_human_leads_count;
            // this.booked_leads_count = response.data.booked_leads_count;
            // this.booked_ai_leads_count = response.data.booked_ai_leads_count;
            // this.booked_human_leads_count = response.data.booked_human_leads_count;

            // this.company_name = response.data.company_name;
            // this.uuid = response.data.uuid;
            // this.ai_started_on = response.data.ai_started_on;
            // this.survey_started_on = response.data.survey_started_on;

            await this.loadDashboard();
            await this.loadDashboard2();

            this.loading = false;
        },

        getUUID() {
          return (this.me) ? this.me.uuid : this.$route.params.uuid;
        },

        async doCreated() {
            let self = this

            self.generateMonths();
            if (this.months.length > 0) {
                this.selectedMonth = this.months[0].value;
                this.updateMonthDates(this.selectedMonth); // Set the dates for the current month
            }

            await this.loadDashboard();
            await this.loadDashboard2();

            this.loading = false;

            // self.getMessages();
        },

        generateMonths() {
          const now = new Date();
          const result = [];

          for (let i = 0; i < 6; i++) {
            const date = new Date(
              now.getFullYear(),
              now.getMonth() - i,
              1
            );

            const value = `${date.getFullYear()}-${String(
              date.getMonth() + 1
            ).padStart(2, '0')}`;

            const label = date.toLocaleString('default', {
              month: 'short',
              year: 'numeric'
            });

            result.push({ value, label });
          }

          this.months = result;
        },

        updateMonthDates() {
          if (!this.selectedMonth) return;

          const [year, month] = this.selectedMonth.split('-');
          this.startDate = `${year}-${month}-01`;

          // Get the last day of the month
          const lastDay = new Date(year, month, 0).getDate();
          this.endDate = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
        },

        async loadDashboard() {

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: this.startDate,
                end_date: this.endDate,
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data = response.data.dashboard_data;

            let diff_days = moment(this.endDate).diff(this.startDate, 'days') + 1;

            let date_prev_start = moment(this.startDate).subtract(diff_days, 'days').format('YYYY-MM-DD');
            let date_prev_end = moment(this.endDate).subtract(diff_days, 'days').format('YYYY-MM-DD');

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency != 'Frequency: Auto') {
              date_prev_start = moment(this.startDate).subtract(1, 'months').format('YYYY-MM-DD');
              date_prev_end = moment(date_prev_start).endOf('month').format('YYYY-MM-DD');
            }

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency == 'Frequency: Auto') {
              date_prev_start = moment(this.startDate).subtract(1, 'months').format('YYYY-MM-DD');
              date_prev_end = moment(date_prev_start).add(1, 'months').format('YYYY-MM-DD');
            }

            if (this.selectedMonth == this.months[0].value) {
              // --- NEW: clamp prev_end day-of-month to "today's" day if prev_end is later in that month ---
              const todayDay = moment().date(); // e.g. 16 on Jan 16
              let prevEnd = moment(date_prev_end, 'YYYY-MM-DD');

              if (prevEnd.date() > todayDay) {
                // set to same month as prevEnd, but with today's day (or last day if month is shorter)
                const clampedDay = Math.min(todayDay, prevEnd.daysInMonth());
                prevEnd.date(clampedDay);
                date_prev_end = prevEnd.format('YYYY-MM-DD');
              }
            }

            console.log('date_prev_start', date_prev_start);
            console.log('date_prev_end', date_prev_end);

            function toBinaryStr(str) {
              const encoder = new TextEncoder();
              // 1: split the UTF-16 string into an array of bytes
              const charCodes = encoder.encode(str);
              // 2: concatenate byte data to create a binary string
              return String.fromCharCode(...charCodes);
            }

            this.reviewsScoreData = btoa(toBinaryStr(JSON.stringify(response.data.reviewsScoreData)));


            let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: date_prev_start,
                end_date: date_prev_end,
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data_prev = response2.data.dashboard_data;
            
            this.calculateComparisons();
          },

        async loadDashboard2() {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: moment().subtract(5, 'months').startOf('month').format('YYYY-MM-DD'),
                end_date: moment().endOf('month').format('YYYY-MM-DD'),
                all_time: 0,
                selected_frequency: "Monthly",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            if (this.ai_started_on) {
                for (var i in response.data.dashboard_data.metrics_chart.labels) {
                    if (moment(response.data.dashboard_data.metrics_chart.labels[i]) >= moment(this.ai_started_on)) {
                        response.data.dashboard_data.metrics_chart.labels[i] = response.data.dashboard_data.metrics_chart.labels[i];
                    }
                }
            }

            this.lineChartMetricsOptions.xaxis.categories = response.data.dashboard_data.metrics_chart.labels;

            this.lineChartMetricsOptions.annotations = {
                xaxis: [
                  {
                    x: moment(this.ai_started_on).format('MMM YYYY'),
                    borderColor: "#008FFB",
                    strokeDashArray: 4,
                    label: {
                      borderColor: "#008FFB",
                      style: {
                        color: "#fff",
                        background: "#008FFB"
                      },
                      text: "AI Started " + moment(this.ai_started_on).format('MM/DD')
                    }
                  },
                  {
                    x: moment(this.survey_started_on).format('MMM YYYY'),
                    borderColor: "#FF4560",
                    strokeDashArray: 4,
                    label: {
                      borderColor: "#FF4560",
                      style: {
                        color: "#fff",
                        background: "#FF4560"
                      },
                      text: "Survey Started " + moment(this.survey_started_on).format('MM/DD')
                    }
                  }
                ]
              }

            this.lineChartMetricsSeries = [
              {
                name: 'Impressions',
                data: response.data.dashboard_data.metrics_chart.datasets['Impressions']
              },
              {
                name: 'Absolute Top Impressions Rate',
                data: response.data.dashboard_data.metrics_chart.datasets['Absolute Top Impressions']
              },
              {
                name: 'Under 30s Response Rate',
                data: response.data.dashboard_data.metrics_chart.datasets['Under 30s Response Rate']
              },
              {
                name: 'Lead Volume',
                data: response.data.dashboard_data.metrics_chart.datasets['Lead Volume']
              },
              {
                name: 'Clicks',
                data: response.data.dashboard_data.metrics_chart.datasets['Clicks']
              },
              {
                name: 'Total Cost',
                data: response.data.dashboard_data.metrics_chart.datasets['Cost']
              },
              {
                name: 'Lead Quality',
                data: response.data.dashboard_data.metrics_chart.datasets['Lead Quality']
              },
              {
                name: 'Credited',
                data: response.data.dashboard_data.metrics_chart.datasets['Credited']
              }
            ];
          },

      calculateComparison(data_now, data_previous) {
        data_now = parseFloat(data_now);
        data_previous = parseFloat(data_previous);

        if (data_now == 0 && data_previous == 0)
          return 0.00;

        if (data_now > 0 && data_previous == 0)
          return 100.00;

        if (data_now == 0 && data_previous > 0)
          return 100.00;

        let percentage;

        if (data_now > data_previous) {
          let x = (data_previous/data_now) * 100
          percentage = 100 - x;
        }
        else {
          let x = (data_now/data_previous) * 100
          percentage = 100 - x;
        }

        if (percentage <= 0)
          percentage = percentage * -1;

        percentage = percentage.toFixed(2);

        return percentage;
      },

      calculateComparisons() {
        // Charged Leads Total
        this.comparisons.charged_leads_total = this.calculateComparison(this.dashboard_data.charged_leads_total, this.dashboard_data_prev.charged_leads_total);
        // END Charged Leads Total


        // Not Charged Leads Total
        this.comparisons.not_charged_leads = this.calculateComparison(this.dashboard_data.not_charged_leads, this.dashboard_data_prev.not_charged_leads);
        // END Not Charged Leads Total


        // Total Leads
        this.comparisons.total_leads = this.calculateComparison(this.dashboard_data.total_leads, this.dashboard_data_prev.total_leads);
        // END Total Leads

        
        // Lead Quality
        this.comparisons.lead_quality = this.calculateComparison(this.dashboard_data.lead_quality, this.dashboard_data_prev.lead_quality);
        // END Lead Quality


        // Total Calls
        this.comparisons.total_calls = this.calculateComparison(this.dashboard_data.total_calls, this.dashboard_data_prev.total_calls);
        // END Total Calls


        // Total Connected Calls
        this.comparisons.total_connected_calls = this.calculateComparison(this.dashboard_data.total_connected_calls, this.dashboard_data_prev.total_connected_calls);
        // END Total Connected Calls


        // Total Message Leads
        this.comparisons.total_message_leads = this.calculateComparison(this.dashboard_data.total_message_leads, this.dashboard_data_prev.total_message_leads);
        // END Total Message Leads


        // Qualified Leads
        this.comparisons.charged_leads = this.calculateComparison(this.dashboard_data.stats.charged_leads, this.dashboard_data_prev.stats.charged_leads);
        // END Qualified Leads


        // Approved Disputes
        this.comparisons.approved_disputes = this.calculateComparison(this.dashboard_data.stats.approved_disputes, this.dashboard_data_prev.stats.approved_disputes);
        // END Approved Disputes


        // Converted Customers
        this.comparisons.converted_customers = this.calculateComparison(this.dashboard_data.stats.converted_customers, this.dashboard_data_prev.stats.converted_customers);
        // END Converted Customers

        // Converted Customers AI
        this.comparisons.converted_customers_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_ai, this.dashboard_data_prev.stats.converted_customers_ai);
        // END Converted Customers AI

        // Converted Customers NON AI
        this.comparisons.converted_customers_non_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_non_ai, this.dashboard_data_prev.stats.converted_customers_non_ai);
        // END Converted Customers NON AI


        // Conversion
        this.comparisons.conversion = this.calculateComparison(this.dashboard_data.stats.conversion, this.dashboard_data_prev.stats.conversion);
        // END Conversion


        // ROI
        this.comparisons.roi = this.calculateComparison(this.dashboard_data.stats.roi, this.dashboard_data_prev.stats.roi);
        // END ROI


        // Total Converted Value
        this.comparisons.total_converted_value = this.calculateComparison(this.dashboard_data.stats.total_converted_value, this.dashboard_data_prev.stats.total_converted_value);
        // END Total Converted Value


        // LSA Response Rate
        this.comparisons.lsa_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_response_rate, this.dashboard_data_prev.stats.lsa_response_rate);
        // END LSA Response Rate


        // LSA Response in less than 30s Rate
        this.comparisons.lsa_30_seconds_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_30_seconds_response_rate, this.dashboard_data_prev.stats.lsa_30_seconds_response_rate);
        // END LSA Response in less than 30s Rate


        // LSA Messages Average Response Rate
        this.comparisons.lsa_messages_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_messages_response_rate, this.dashboard_data_prev.stats.lsa_messages_response_rate);
        // END LSA Messages Average Response Rate


        // Total Impressions
        this.comparisons.total_impressions = this.calculateComparison(this.dashboard_data.stats.total_impressions, this.dashboard_data_prev.stats.total_impressions);
        // END Total Impressions


        // Total Clicks
        this.comparisons.total_clicks = this.calculateComparison(this.dashboard_data.stats.total_clicks, this.dashboard_data_prev.stats.total_clicks);
        // END Total Clicks


        // Total Cost
        this.comparisons.total_cost = this.calculateComparison(this.dashboard_data.stats.total_cost, this.dashboard_data_prev.stats.total_cost);
        // END Total Cost
      }
    },

    destroyed() {
        clearTimeout(this.thisProc);
        this.thisProc = null;
    },

    created() {
        this.readCutoffFromQuery();
        this.doCreated();
    },
}
</script>


<style scoped>
.intake-tooltip {
  max-width: 320px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
}

/* Normalize icon look/feel so they don't jump around across rows */
.rg-channel-icon {
    width: 22px;
    height: 22px;
    display: inline-block;
    object-fit: contain;
}

.custom-text-field .v-input__control input {
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid red;
}
.header-inputs {
border-color: white !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
color: rgba(0, 0, 0, 0.38);
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid white !important;
}

.status-chip {
font-weight: bold;
text-transform: uppercase;
}

.status-Qualified {
color: green !important;
border-color: green !important;

}

.status-inQualified {
color: red;
border-color: red;
}

.custom-badge {
background-color: rgba(0, 230, 130, 0.1) !important;
color: #09ad95 !important;
}

.tags {
color: #e0e0e0;
font-size: small;
padding-left: 5px;

}

.icon-container {
display: flex;
align-items: center;
justify-content: center;
width: 48px;
height: 48px;
border-radius: 50%;
border: 2px solid #ccc;
cursor: pointer;
}

.icon {
font-size: 24px;
}

textarea:focus, input:focus{
    outline: none;
}

.stats-btn .stats-div {
    display: none;
}

.stats-btn:hover .stats-div {
    display: block;
}
</style>

<style scoped>
.score-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.legend-title {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
}

.legend-items {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
}

.legend-badge {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

/* Score colors */
.score-1 { background: #16a34a; } /* very good */
.score-2 { background: #22c55e; } /* good */
.score-3 { background: #facc15; color: #FFFFFF; } /* neutral */
.score-4 { background: #fb923c; } /* bad */
.score-5 { background: #ef4444; } /* very bad */


</style>

<style type="text/css">
  .new-lead-highlight {
    background-color: #fff7cc !important;
    border-left: 4px solid #f5c518 !important;
  }

  .new-lead-highlight td {
    background-color: #fff7cc !important;
  }

  .custom-legend.centered {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 12px;
}

.custom-legend-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
  opacity: 1;
}

.custom-legend-item.dimmed {
  opacity: 0.3;
}

.custom-legend-item.disabled {
  opacity: 0.3;
}


.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;
  display: inline-block;
}

.legend-label {
  font-size: 13px;
  font-weight: 400;
  color: #444;
}

</style>